var excluded_list = [
    "0815.ru",
    "10minutemail.com",
    "10minutemail.co.za",
    "2trom.com",
    "33mail.com",
    "6ip.us",
    "abyssmail.com",
    "accountant.com",
    "acdcfan.com",
    "activist.com",
    "adexec.com",
    "africamail.com",
    "aircraftmail.com",
    "allergist.com",
    "alumni.com",
    "alumnidirector.com",
    "anappthat.com",
    "angelic.com",
    "appraiser.net",
    "archaeologist.com",
    "arcticmail.com",
    "armyspy.com",
    "artlover.com",
    "asia.com",
    "asia-mail.com",
    "atheist.com",
    "auctioneer.net",
    "australiamail.com",
    "bartender.net",
    "bellair.net",
    "berlin.com",
    "bikerider.com",
    "binkmail.com",
    "birdlover.com",
    "blader.com",
    "boardermail.com",
    "bobmail.info",
    "boun.cr",
    "brazilmail.com",
    "brennendesreich.de",
    "brew-master.com",
    "brew-meister.com",
    "bsdmail.com",
    "bund.us",
    "cachedot.net",
    "californiamail.com",
    "cash4u.com",
    "cashforcarsbristol.co.uk",
    "catlover.com",
    "ce.mintemail.com",
    "chammy.info",
    "cheerful.com",
    "chef.net",
    "chemist.com",
    "chinamail.com",
    "clerk.com",
    "clrmail.com",
    "clubmember.org",
    "collector.org",
    "columnist.com",
    "comic.com",
    "computer4u.com",
    "consultant.com",
    "contractor.net",
    "coolsite.net",
    "counsellor.com",
    "cutey.com",
    "cuvox.de",
    "cyberdude.com",
    "cybergal.com",
    "cyberservices.com",
    "cyber-wizard.com",
    "dacoolest.com",
    "dallasmail.com",
    "dayrep.com",
    "dbzmail.com",
    "deliveryman.com",
    "devnullmail.com",
    "diplomats.com",
    "discard.email",
    "discardmail.com",
    "discardmail.de",
    "disciples.com",
    "discofan.com",
    "dispomail.eu",
    "disposable.com",
    "dispostable.com",
    "doctor.com",
    "dodgit.com",
    "doglover.com",
    "doramail.com",
    "dr.com",
    "drdrb.com",
    "dublin.com",
    "dutchmail.com",
    "eelmail.com",
    "einrot.com",
    "elvisfan.com",
    "email.com",
    "emailproxsy.com",
    "engineer.com",
    "englandmail.com",
    "europe.com",
    "europemail.com",
    "execs.com",
    "fakeinbox.com",
    "fastservice.com",
    "filzmail.com",
    "financier.com",
    "fireman.net",
    "fleckens.hu",
    "galaxyhit.com",
    "gardener.com",
    "geologist.com",
    "germanymail.com",
    "getairmail.com",
    "gmx.com",
    "gmx.us",
    "graduate.org",
    "graphic-designer.com",
    "greenmail.net",
    "groupmail.com",
    "grr.la",
    "guerrillamail.biz",
    "guerrillamailblock.com",
    "guerrillamail.com",
    "guerrillamail.de",
    "guerrillamail.net",
    "guerrillamail.org",
    "gustr.com",
    "hackermail.com",
    "hairdresser.net",
    "harakirimail.com",
    "hilarious.com",
    "hiphopfan.com",
    "hmamail.com",
    "homemail.com",
    "hot-shot.com",
    "housemail.com",
    "hulapla.de",
    "humanoid.net",
    "hushmail.com",
    "imgof.com",
    "imgv.de",
    "iname.com",
    "inboxproxy.com",
    "incognitomail.org",
    "innocent.com",
    "inorbit.com",
    "instruction.com",
    "instructor.net",
    "insurer.com",
    "irelandmail.com",
    "israelmail.com",
    "italymail.com",
    "job4u.com",
    "journalist.com",
    "jourrapide.com",
    "keromail.com",
    "kissfans.com",
    "kittymail.com",
    "koreamail.com",
    "lags.us",
    "leeching.net",
    "legislator.com",
    "letthemeatspam.com",
    "linuxmail.org",
    "lobbyist.com",
    "lovecat.com",
    "madonnafan.com",
    "maildrop.cc",
    "mailforspam.com",
    "mailhub.pw",
    "mailimate.com",
    "mailinator2.com",
    "mailinator.com",
    "mailinator.net",
    "mail-me.com",
    "mailnesia.com",
    "mailnull.com",
    "mailproxsy.com",
    "mailtothis.com",
    "marchmail.com",
    "meltmail.com",
    "metalfan.com",
    "mexicomail.com",
    "minister.com",
    "mintemail.com",
    "moscowmail.com",
    "mt2015.com",
    "munich.com",
    "musician.org",
    "muslim.com",
    "my10minutemail.com",
    "mynetstore.de",
    "myself.com",
    "mytrashmail.com",
    "net-shopping.com",
    "ninfan.com",
    "nonpartisan.com",
    "nonspam.eu",
    "nonspammer.de",
    "notmailinator.com",
    "null.net",
    "nycmail.com",
    "oath.com",
    "optician.com",
    "orthodontist.net",
    "pacific-ocean.com",
    "pacificwest.com",
    "pediatrician.com",
    "petlover.com",
    "photographer.net",
    "physicist.net",
    "planetmail.com",
    "planetmail.net",
    "polandmail.com",
    "politician.com",
    "post.com",
    "presidency.com",
    "priest.com",
    "programmer.net",
    "protestant.com",
    "publicist.com",
    "pwrby.com",
    "qoika.com",
    "qualityservice.com",
    "radiologist.net",
    "ravemail.com",
    "reallymymail.com",
    "realtyagent.com",
    "reborn.com",
    "reconmail.com",
    "reggaefan.com",
    "registerednurses.com",
    "reincarnate.com",
    "religious.com",
    "repairman.com",
    "representative.com",
    "rescueteam.com",
    "rhyta.com",
    "rocketship.com",
    "s0ny.net",
    "safetymail.info",
    "safrica.com",
    "saintly.com",
    "salesperson.net",
    "samerica.com",
    "sanfranmail.com",
    "scotlandmail.com",
    "secretary.net",
    "sendspamhere.com",
    "sharedmailbox.org",
    "sharklasers.com",
    "snakebite.com",
    "socialworker.net",
    "sociologist.com",
    "sogetthis.com",
    "solution4u.com",
    "songwriter.net",
    "soodonims.com",
    "spainmail.com",
    "spam4.me",
    "spamavert.com",
    "spambog.com",
    "spambog.de",
    "spambog.ru",
    "spambooger.com",
    "spambox.us",
    "spamgourmet.com",
    "spamherelots.com",
    "spamhereplease.com",
    "spamhole.com",
    "spamstack.net",
    "spamthisplease.com",
    "stonerfans.com",
    "streetwisemail.com",
    "superrito.com",
    "suremail.info",
    "surgical.net",
    "swedenmail.com",
    "swissmail.com",
    "tafmail.com",
    "teachers.org",
    "tech-center.com",
    "techie.com",
    "technologist.com",
    "teewars.org",
    "teleworm.us",
    "thehighlands.co.uk",
    "theplate.com",
    "therapist.net",
    "thisisnotmyrealemail.com",
    "throwawayemailaddress.com",
    "toke.com",
    "toothfairy.com",
    "torontomail.com",
    "tradermail.info",
    "tvstar.com",
    "umpire.com",
    "usa.com",
    "uymail.com",
    "value-mycar.co.uk",
    "veryrealemail.com",
    "webname.com",
    "worker.com",
    "workmail.com",
    "writeme.com",
    "yopmail.com",
    "zetmail.com",
    "zippymail.info",
    "zxcvbnm.co.uk",
    "test.com",
    "abc.com",
    "abc.xyz"
];
export var checkDomainValidity = function (email) {
    var enteredDomain = email.split('@')[1]; // Extracting domain from the entered email
    var check = excluded_list.includes(enteredDomain);
    return check;
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/excludedDomains.ts
// module id = null
// module chunks = 